// ==================== AboutSection.js ====================
import React from 'react';

const AboutSection = () => (
  <section id="section-4" className="py-24 bg-gradient-to-b from-purple-50 to-blue-50">{/* Changed background */}
    <div className="max-w-6xl mx-auto px-6">
      <div className="text-center mb-20">
        <h2 className="text-5xl lg:text-6xl font-bold mb-6 text-gray-900">
          Our story
        </h2>
      </div>

      <div className="bg-white rounded-3xl p-12 mb-20 shadow-lg">{/* Added shadow */}
        <div className="max-w-4xl mx-auto">
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            We started this company because we saw how broken the job hunt can be — especially for Gen Z and young professionals.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed mb-8 font-bold text-center">
            Resumes pile up. LinkedIn messages get ignored. You're told to "network more" without any real guidance.
          </p>
          <p className="text-xl text-gray-700 leading-relaxed">
            So we decided to flip the script. We built a service that does the hard work for you: crafting your story, 
            getting you in front of the right people, and keeping you encouraged every step of the way. 
            Because landing your dream job shouldn't feel like a full-time job.
          </p>
        </div>
      </div>

      
    </div>
  </section>
);

export default AboutSection;